import {EventEmitter} from 'fbemitter';

let OrmEvents = new EventEmitter();
export {OrmEvents};